import { Column } from '@simplywallst/ui-core';
import { HeroContentRow, HeroContent } from './styled';

interface Props {
  title?: string;
  shortContentOne?: string;
}

export const Hero = ({ title, shortContentOne }: Props) => {
  return (
    <HeroContentRow>
      <Column displayFlex alignItem="center">
        <HeroContent data-cy-id="hero">
          <h1>{title}</h1>
          <p>{shortContentOne}</p>
        </HeroContent>
      </Column>
    </HeroContentRow>
  );
};
